module.exports = __webpack_public_path__ + "static/media/trellis_logo_full_color_dots_only.4cf5f15f.png";